import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BulkActions extends Component {
    render() {
        const {onChange, selectAll} = this.props

        return (
            <input type='checkbox' checked={selectAll} onChange={onChange}/>
        )
    }
}

BulkActions.propTypes = {
    onChange: PropTypes.func.isRequired,
    selectAll: PropTypes.bool,
    arrSelected: PropTypes.array,
}

export default BulkActions
